import anime from 'animejs';

const heroPicture = (el) => {
  const animation = anime({
    targets: el.node,
    duration: 400,
    opacity: [0, 1],
    easing: 'easeInOutSine',
  });

  return animation;
};

export default heroPicture;
